import { render, staticRenderFns } from "./VodBandwidth.vue?vue&type=template&id=3e2f637a&scoped=true"
import script from "./VodBandwidth.vue?vue&type=script&lang=js"
export * from "./VodBandwidth.vue?vue&type=script&lang=js"
import style0 from "./VodBandwidth.vue?vue&type=style&index=0&id=3e2f637a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f637a",
  null
  
)

export default component.exports